import { Grid } from '@mui/material';
import { HexColor } from '@nx-smartmonkey/shared/domain';
import { RoutalColorPicker } from '@nx-smartmonkey/ui';

import { RightPanelHeader } from '../../../../components/right-panel-info/RightPanel.styled';
import { GeoFence } from '../../../../domain/geoFence/GeoFence';
import { useUpdateProjectGeoFence } from '../../../../hooks/project/useUpdateProjectGeoFence';
import { GeoFenceMapper } from '../../../../mappers/geoFence/GeoFenceMapper';
import Text from '../../../../react-components/Text';

type PlanGeoFenceHeaderProps = {
  geoFence: GeoFence;
  onClose: (...args: any[]) => any;
  options?: React.ReactElement | any;
};

export const PlanGeoFenceHeader = ({ geoFence, options, onClose }: PlanGeoFenceHeaderProps) => {
  const { run: updateGeoFence } = useUpdateProjectGeoFence();
  if (geoFence) {
    return (
      <RightPanelHeader onClose={onClose}>
        <Grid container direction="row" wrap="nowrap" alignItems="center">
          <Grid item container justifyContent="flex-start" style={{ width: `100%` }} wrap="nowrap" alignItems="center">
            <RoutalColorPicker
              color={geoFence.color.value}
              colorSampleStyles={{
                padding: `2px 8px`,
                margin: `0 2px`,
                color: `white`,
                borderRadius: `4px`,
              }}
              colorSampleContent={
                <Text tagName="span" style={{ color: `white`, cursor: `pointer`, fontSize: 10 }}>
                  {geoFence.getShortLabel()}
                </Text>
              }
              onUpdate={(color: string) => {
                geoFence.color = HexColor.create(color);
                updateGeoFence({ geoFence: GeoFenceMapper.cloneDomain(geoFence) });
              }}
            />
          </Grid>

          <Grid container direction="row" style={{ width: `auto` }} wrap="nowrap" alignItems="center">
            {options}
          </Grid>
        </Grid>
      </RightPanelHeader>
    );
  }
  return null;
};
